/**
 * A caixa do aceite (docs/spec/termos.md): "Tenho 18 anos ou mais e aceito os Termos de Uso e a
 * Política de Privacidade", com os dois nomes como links. O link abre o texto num diálogo (`onView`),
 * sem tirar a pessoa do formulário; o clique nele não marca a caixa (o link é interativo dentro do
 * rótulo). Abrir o link noutra aba leva à página pública do texto.
 */
import { Fragment, type CSSProperties, type ReactNode } from 'react';
import { useLanguage, useT } from '../i18n/index.js';
import { legalPath, type LegalDoc } from '../legal/documents.js';
import { MIN_AGE } from '../shared.js';
import { CheckBox } from '../ui/controls.js';

export function TosConsent({
  checked,
  onChange,
  invalid,
  onView,
  style,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  invalid?: boolean;
  onView: (doc: LegalDoc) => void;
  style?: CSSProperties;
}) {
  const t = useT();
  const language = useLanguage((s) => s.language);
  const link = (doc: LegalDoc) => (
    <a
      className="rd-tos__link"
      href={legalPath(doc, language)}
      onClick={(event) => {
        event.preventDefault();
        onView(doc);
      }}
    >
      {t(`legal.${doc}.title`)}
    </a>
  );
  return (
    <CheckBox checked={checked} onChange={onChange} alignTop style={{ fontSize: 13, ...(invalid ? { color: 'var(--error-color)' } : {}), ...style }}>
      {withParts(t('register.acceptTos', { age: MIN_AGE }), { terms: link('terms'), privacy: link('privacy') })}
    </CheckBox>
  );
}

/** Troca `{nome}` do texto por um pedaço do React (os links). */
function withParts(text: string, parts: Record<string, ReactNode>): ReactNode[] {
  return text.split(/(\{\w+\})/).map((piece, i) => {
    const name = /^\{(\w+)\}$/.exec(piece)?.[1];
    return <Fragment key={i}>{name && name in parts ? parts[name] : piece}</Fragment>;
  });
}
